// Filter.js
import React from 'react';
import "./Filter.scss";

const Filter = ({ onChange, setSearchItemId, searchInputRef, onFilterChange, minLvl, handleMinLvlChange, maxLvl, handleMaxLvlChange  }) => {

  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchItemId(value);
    onChange(value);
  };

  const handleInputMin = (event) => {
    handleMinLvlChange(event);
  };
  
  const handleInputMax = (event) => {
    handleMaxLvlChange(event);
  };
  
  return (
    <div className='filter'>
      <div className="filter__search__wrapper">
        <input ref={searchInputRef} onChange={handleInputChange} placeholder="Nom de l'item" type="text" className='filter__search' />
        <input onChange={handleInputMin}  value={minLvl} placeholder='Lvl mini' type="number" className='filter__minlvl' />
        <input onChange={handleInputMax}  value={maxLvl} placeholder='Lvl max' type="number" className='filter__maxlvl' />
      </div>
    </div>
  );
};

export default Filter;
